import { useMemo } from 'react';
import { translate } from '@utils/i18n';
const useComponentFilters = ({ filters, onFiltersChange, componentTypes }) => {
    const filtersList = useMemo(() => {
        const list = [];
        // Active State Filter (single-select: all / active / inactive)
        list.push({
            type: 'select',
            field: 'activeState',
            label: translate('active_state', { namespace: 'filters' }),
            value: filters.activeState,
            onChange: (v) => {
                var _a;
                onFiltersChange(Object.assign(Object.assign({}, filters), { activeState: ((_a = v) !== null && _a !== void 0 ? _a : 'active') }));
            },
            options: [
                { value: 'all', label: translate('filter_panel.active_state.all', { namespace: 'components' }) },
                { value: 'active', label: translate('filter_panel.active_state.active', { namespace: 'components' }) },
                { value: 'inactive', label: translate('filter_panel.active_state.inactive', { namespace: 'components' }) }
            ]
        });
        // Component Type Filter (multi-select) — only rendered when types exist
        if ((componentTypes === null || componentTypes === void 0 ? void 0 : componentTypes.length) > 0) {
            list.push({
                type: 'multiSelect',
                field: 'typeIds',
                label: translate('component_type', { namespace: 'filters' }),
                value: filters.typeIds,
                onChange: (v) => {
                    onFiltersChange(Object.assign(Object.assign({}, filters), { typeIds: v }));
                },
                options: componentTypes.map((type) => ({
                    value: type.id,
                    label: type.typeName
                }))
            });
        }
        return list;
    }, [filters, componentTypes, onFiltersChange]);
    return filtersList;
};
export default useComponentFilters;
